import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { NotificationProvider } from './components/utils/Notification';
import { StoreProvider } from './components/utils/Store';
import "../src/components/utils/transl";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoreProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </StoreProvider>
  </React.StrictMode>
);

